import { BaseAccountModel, CountriesType } from '@hwm/ui-lib';

export enum PermissionsEnum {
  CanSeeAndEditFleetReports = 'Can see and edit fleet reports',
  CanEditSite = 'Can edit sites',
  CanRemotelyControlDevices = 'Can remotely control devices',
  CanSetAlarms = 'Can set alarms',
  CanSeeAnyAccount = 'Can see any account',
  CanAcknowledgeAlarms = 'Can acknowledge alarms',
  CanSeeEclRsrpRsrqInfo = 'Can see ECL, RSRP, RSRQ info',
}

export enum FeatureFlagsEnum {
  AllowAllSearchField = 'AllowAllSearchField',
}

export interface AccountModel extends BaseAccountModel {
  ancestors?: AccountModel[];
  timeOffsetSeconds?: number;
}

export interface UserMainAccountModel extends BaseAccountModel {
  ancestors?: BaseAccountModel[];
  languageCode?: CountriesType;
  userId?: number;
  userName?: string;
  logoUrl?: string;
  useZones?: boolean;
}
